import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

Component('tr-list-item-form', {
  mixins: [eventListenerMixin],

  connected() {
    this.listenTo(this.querySelector('.cancel-button'), 'click', () => this.remove());
    this.querySelector('.list-item-name-input input').focus();
  },

  disconnected() {
    this.stopListening();
  },
});
